import { createFileRoute } from "@tanstack/react-router"

import { AccessControlSettingsPage } from "@/features/settings/components/access-control-settings-page"

export const Route = createFileRoute("/dashboard/settings/access-control/")({
	component: AccessControlSettingsPage,
})
